import React, { Component } from 'react';
import legaleyseLogo from '../../shared/images/legaleyse-logo.svg';
import { Link, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { login, setPassword, setUsername } from './redux/actions';
import './Login.scss';
import { InputField } from '../../shared/input-field/InputField';
import { SubmitButton } from '../../shared/button/submit-button/SubmitButton';
import { sessionEndedMessage } from './session-ended';

class Login extends Component {
    constructor(props) {
        super(props);
        this.handleUsernameChange = this.handleUsernameChange.bind(this);
        this.handlePasswordChange = this.handlePasswordChange.bind(this);
        this.handleLogin = this.handleLogin.bind(this);
    }

    handleUsernameChange(event) {
        this.props.setUsername(event.target.value);
    }

    handlePasswordChange(event) {
        this.props.setPassword(event.target.value);
    }

    handleLogin(event) {
        event.preventDefault();
        this.props.login(this.props.username, this.props.password);
    }

    render() {
        const { authenticated, username, password, sessionEnded } = this.props;
        if (authenticated) {
            return <Redirect to="/dashboard" />;
        }

        return (
            <div className={'main-container'}>
                <div className="login-container">
                    <img
                        alt={'Legaleyse Logo'}
                        className="logo"
                        src={legaleyseLogo}
                    />
                    <span className="welcome-message">Welcome back</span>
                    {sessionEnded && (
                        <div className="session-ended-note" role="alert">
                            <i className="material-icons">info</i>
                            <span>{sessionEndedMessage}</span>
                        </div>
                    )}
                    <form className={'login-form'} onSubmit={this.handleLogin}>
                        <InputField
                            type="text"
                            name="username"
                            placeholder="Email or username"
                            value={username}
                            onChange={this.handleUsernameChange}
                            required={true}
                        />
                        <InputField
                            type="password"
                            name="password"
                            placeholder="Password"
                            value={password}
                            onChange={this.handlePasswordChange}
                            required={true}
                        />
                        <SubmitButton text={'Login'} />
                    </form>
                    <Link className="forgot-password-link" to="/reset-password">
                        Forgot Password?
                    </Link>

                    <div className="login-footer">
                        <div className="footer-circle">
                            <div className={'footer-circle-content'}>@</div>
                        </div>
                        <div className="login-footer-rectangle">
                            <div>
                                <span>Got a question for us?</span>
                                {/*todo: no link!*/}
                                <a href="_blank">Get in touch</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = ({ authentication }) => {
    return authentication;
};
const mapDispatchToProps = dispatch => ({
    login: (username, password) => dispatch(login({ username, password })),
    setUsername: username => dispatch(setUsername(username)),
    setPassword: password => dispatch(setPassword(password))
});

export default connect(mapStateToProps, mapDispatchToProps)(Login);
